// src/api/api.js
import axios from 'axios';
import { getLoginPath } from '../utils/appPath';

const api = axios.create({
  // baseURL: 'http://localhost:5000/api',
  baseURL: '/api',

  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajouter token JWT automatiquement
api.interceptors.request.use((config) => {
  const user = localStorage.getItem('authUser');
  const token = user ? JSON.parse(user).token : null;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// déconnexion / redirection si token expiré ou invalide (pas sur l'échec du formulaire login : 401 attendu)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const cfg = error.config || {};
      const url = String(cfg.url || '').split('?')[0];
      const baseURL = String(cfg.baseURL || '');
      const combined = `${baseURL}${url}`.split('?')[0];
      const isLoginRequest =
        url === '/users/login' ||
        url.endsWith('/users/login') ||
        combined.endsWith('/users/login') ||
        /\/users\/login$/.test(combined);
      if (isLoginRequest) {
        return Promise.reject(error);
      }
      localStorage.removeItem('authUser');
      window.location.href = getLoginPath();
    }
    return Promise.reject(error);
  }
);

export default api;
